import { sprintf } from 'sprintf-js';

class SeoTemplate {
  template: any;

  type: any;

  constructor(type: any, template: any) {
    this.type = type;
    this.template = template;
    Object.freeze(this);
  }

  format(object: any) {
    return sprintf(this.template, object);
  }
}

export default SeoTemplate;
